export const MultiLineChart = ({ data, activeChannel, className = "" }) => {
  // Get the appropriate data based on active channel
  const getChartData = () => {
    if (activeChannel === "All Channels") {
      return data.map((d) => ({
        month: d.month,
        value: d.voice + d.chat + d.email,
      }));
    } else if (activeChannel === "Voice") {
      return data.map((d) => ({ month: d.month, value: d.voice }));
    } else if (activeChannel === "Chat") {
      return data.map((d) => ({ month: d.month, value: d.chat }));
    } else if (activeChannel === "Email") {
      return data.map((d) => ({ month: d.month, value: d.email }));
    }
    return data.map((d) => ({
      month: d.month,
      value: d.voice + d.chat + d.email,
    }));
  };

  const chartData = getChartData();
  const maxValue = Math.max(...chartData.map((d) => d.value));
  const minValue = Math.min(...chartData.map((d) => d.value));
  const range = maxValue - minValue || 1;

  // Create SVG path
  const createPath = () => {
    const width = 800;
    const height = 200;
    const padding = 40;

    const points = chartData.map((point, index) => {
      const x =
        padding + (index * (width - 2 * padding)) / (chartData.length - 1);
      const y =
        height -
        padding -
        ((point.value - minValue) / range) * (height - 2 * padding);
      return `${x},${y}`;
    });

    return `M ${points.join(" L ")}`;
  };

  const yAxisValues = [0, 50, 100, 150, 200, 250];

  return (
    <div className={`w-full h-64 bg-gray-50 rounded-lg p-4 ${className}`}>
      <svg
        width="100%"
        height="100%"
        viewBox="0 0 800 200"
        className="overflow-visible"
      >
        {/* Grid lines */}
        {yAxisValues.map((y, i) => (
          <line
            key={i}
            x1="40"
            y1={40 + i * 25}
            x2="760"
            y2={40 + i * 25}
            stroke="#e5e7eb"
            strokeWidth="1"
          />
        ))}

        {/* Chart line */}
        <path
          d={createPath()}
          fill="none"
          stroke="#3b82f6"
          strokeWidth="2"
          className="drop-shadow-sm"
        />

        {/* Data points */}
        {chartData.map((point, index) => {
          const x = 40 + (index * 720) / (chartData.length - 1);
          const y = 160 - ((point.value - minValue) / range) * 120;
          return (
            <circle
              key={index}
              cx={x}
              cy={y}
              r="4"
              fill="#3b82f6"
              className="drop-shadow-sm"
            />
          );
        })}

        {/* X-axis labels */}
        {chartData.map((point, index) => {
          const x = 40 + (index * 720) / (chartData.length - 1);
          return (
            <text
              key={index}
              x={x}
              y="190"
              textAnchor="middle"
              className="text-xs fill-gray-500"
            >
              {point.month}
            </text>
          );
        })}

        {/* Y-axis labels */}
        {yAxisValues.map((value, i) => (
          <text
            key={i}
            x="30"
            y={165 - i * 25}
            textAnchor="end"
            className="text-xs fill-gray-500"
          >
            {value}
          </text>
        ))}
      </svg>
    </div>
  );
};
